import axios from 'axios';

export default {
  namespaced: true,
  state: {
    suggestions: [],
    endpoint: '/search-suggestions.json',
    loaded: false
  },

  getters: {
    filter: (state) => search => {
      return state.suggestions.filter(result => { return result.toLowerCase().indexOf(search.toLowerCase()) === 0 });
    }
  },

  mutations: {
    setSuggestions(state, suggestions) {
      state.suggestions = suggestions;
    }
  },

  actions: {
    fetch({state, commit}) {
      axios.get(state.endpoint)
        .then(function (response) {
          state.loaded = true;
          commit('setSuggestions', response.data['#items']);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
};
